import { createStore } from 'vuex'

export default createStore({
  state: {
    modal_video: null,
    familyTransition: false,
  },
  mutations: {
    openFamilyOffice(state, isOpen = true) {
      state.familyTransition = isOpen
    },
    setModalVideo(state, video = null) {
      state.modal_video = video
    },
  },
  actions: {
    closeModalVideo(context) {
      context.commit('setModalVideo', null)
    },
    openFamilyOffice(context, isOpen = true) {
      context.commit('openFamilyOffice', isOpen)
    },
    openModalVideo(context, video) {
      context.commit('setModalVideo', video)
    },
  },
})
